export enum DateFormat {
  DD_MM_YYYY_DASH = 'DD-MM-YYYY',
  DD_MM_YYYY_HH_MM_DASH = 'DD-MM-YYYY HH:mm',
  DD_MM_YYYY_SLASH = 'DD/MM/YYYY',
  DD_MM_YYYY_EXTENDED = 'DD MMM. YYYY',
}
